import { SiteplanView } from 'Views/siteplan/SiteplanView';
export default SiteplanView;
